export default __webpack_public_path__ + "static/Goodfirms-947076070f29fa5a870ceb1d6545bbb6.png";